import { Fragment, useEffect, useRef, useState } from "react";
import { datagridCustomStore } from "../../../shared/devexpress";
import { persianLanguage } from "../../../constants/persianTerms";
import { persianPrice } from "../../../shared/persian-number";
import DevextremeDataGrid from "../../components/devextreme-data-grid/DevextremeDataGrid";
import { DATAGRID_ALLOWED_FILTER_OPERATIONS, DATAGRID_ALLOWED_PAGE_SIZES } from "../../../constants/constant-arrays";
import { FARVARDINGOLD_GOLD_PRICE_ACTIVENESSES, GOLD_PRICE_ACTIVENESS_HISTORY_API, T1_GOLD_PRICE_ACTIVENESSES, } from "../../../constants/api";
import PageTitle from "../../components/page-title/PageTitle";
import { calculatePersianNowDateNumber, convertPersianDateToNumber, convertPersianDateToPersianDateEnglishDigit } from "../../../shared/date-and-time-conversion";
import SimpleDatePickerInput from "../../report/components/simple-date-picker-input/SimpleDatePickerInput";
import { API_KEY } from "../../../constants/api-key";


export default function GoldPriceHistory(){
    
  const [goldPrices, setGoldPrices] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const dataGridRef = useRef(null);

  const [allowedFilterOperation, setAllowedFilterOperation] = useState(DATAGRID_ALLOWED_FILTER_OPERATIONS);
  const [selectedStartDate, setSelectedStartDate] = useState("");
  const [selectedEndDate, setSelectedEndDate] = useState("");
  const [startUnixDate, setStartUnixDate] = useState(null);
  const [endUnixDate, setEndUnixDate] = useState(null);
  
  const [startDateThresholdActivated, setStartDateThresholdActivated] = useState(false);
  const [wrongStartDate, setWrongStartDate] = useState(false);
  const [wrongEndDate, setWrongEndDate] = useState(false);
  const [dateFilters, setDateFilters] = useState([[] , []]);



    useEffect(() => {
        getGoldPrices([]);
    },[
        goldPrices?.length,
    ])

    const getGoldPrices = (filters) => {
        let activeFilters = [];
  
        console.log('dateFilters isisissi: ', dateFilters)
        console.log('active filters: ', activeFilters)
        
        const res = datagridCustomStore(
          'id', 
          `${FARVARDINGOLD_GOLD_PRICE_ACTIVENESSES}`,
          filters, 
          'devextreme',
          API_KEY,
        );
        
        setGoldPrices(res);
    }
  
  const calculatePriceCellValue = (rowData) => {
    return persianPrice(rowData.price);
  }


  const changeStartDate = (unix, formatted) => {
    checkStartDateMeetThreshold(formatted);
    setStartUnixDate(unix);
    setSelectedStartDate(formatted);
    checkStartDateValidity(formatted);

    // Build the filters array
    const newFilters = [];
    if (selectedEndDate) {
      newFilters.push(['createdOn', '<', selectedEndDate]);
    }
    if (formatted) {
      newFilters.push(['createdOn', '>', formatted]);
    }

    setDateFilters(newFilters);
    getGoldPrices(newFilters)
  }

  const compareStartDateWithNow = (startDate) => {
    if(startDate){
      let startDateNumber = convertPersianDateToNumber(startDate);
      let nowIs = calculatePersianNowDateNumber();
      if (startDateNumber > nowIs){
        return true;          
      }
    }
    return false;
  }

  const compareEndDateWithNow = (endDate) => {
    if(endDate){
      let endDateNumber = convertPersianDateToNumber(endDate);
      let nowIs = calculatePersianNowDateNumber();
      if (endDateNumber > nowIs){
        return true;          
      }
    }
    return false;
  }

  const compareStartDateWithEndDate = (startDate) => {
    if(selectedEndDate && startDate){
      let startDateNumber = convertPersianDateToNumber(startDate);
      let endDateNumber = convertPersianDateToNumber(selectedEndDate);
      if(startDateNumber > endDateNumber){
        return true;
      }
    }
    return false;
  }

  const compareEndDateWithStartDate = (endDate) => {
    if(endDate && selectedStartDate){
      let startDateNumber = convertPersianDateToNumber(selectedStartDate);
      let endDateNumber = convertPersianDateToNumber(endDate);
      if(startDateNumber > endDateNumber){
        return true; 
      }
    }
    return false;
  }

  const checkStartDateValidity = (startDate) => {
    const result1 = compareStartDateWithNow(startDate);
    const result2 = compareStartDateWithEndDate(startDate);
    if(result1 === true || result2 === true){
      setWrongStartDate(true);
    } else {
      setWrongStartDate(false);
    }
  }

  const checkEndDateValidity = (endDate) => {
    const result1 = compareEndDateWithNow(endDate);
    const result2 = compareEndDateWithStartDate(endDate);
    if(result1 === true || result2 === true){
      setWrongEndDate(true);
    } else {
      setWrongEndDate(false);
    }
  }

  const changeEndDate = (unix, formatted) => {
    setEndUnixDate(unix);
    setSelectedEndDate(formatted);
    checkEndDateValidity(formatted);

    const newFilters = [];
    if (formatted) {
      newFilters.push(['createdOn', '<', formatted]);
    }
    if (selectedStartDate) {
      newFilters.push(['createdOn', '>', selectedStartDate]);
    }

    setDateFilters(newFilters);
    getGoldPrices(newFilters)
  }

  const checkStartDateMeetThreshold = (startDate) => {
    const today = new Date()
    let thresholdDate = new Date(new Date().setDate(today.getDate() - 30)).toLocaleDateString('fa-EN');
    thresholdDate = convertPersianDateToPersianDateEnglishDigit(thresholdDate);
    const thresholdDateNumber = convertPersianDateToNumber(thresholdDate);
    const startDateNumber = convertPersianDateToNumber(startDate);
    if(startDateNumber < thresholdDateNumber){
      setStartDateThresholdActivated(true);
    } else {
      setStartDateThresholdActivated(false);
    }
  }

  const columns = [
    { dataField: 'createdOn', 
      caption: persianLanguage.phrase.general.CREATED_ON,
      allowFiltering: false,
    },
    { 
      dataField: 'price', 
      caption: persianLanguage.word.price.PRICE,
      allowFiltering: true,
      calculateCellValue: calculatePriceCellValue
    },
    { dataField: 'priceTypeTitle', 
      caption: persianLanguage.word.price.PRICE_TYPE,
      allowFiltering: true,
      width:100,

    },
    { dataField: 'isActiveTitle', 
      caption: `${persianLanguage.word.general.ACTIVE}/${persianLanguage.word.general.DEACTIVE}`,
      allowFiltering: true,
      width:130,
    },
    { dataField: 'quantityDefinitionTitle', 
      caption: persianLanguage.word.general.QUANTITY,
      allowFiltering: true,
    },
    { dataField: 'ipAddress', 
      caption: persianLanguage.word.user.ADDRESS,
      allowFiltering: true,
      width:130,
    },
    { dataField: 'createdBy',
      caption: `${persianLanguage.phrase.general.CREATED_BY}`,
      allowFiltering: true,
    },
  ];
      

  const onSelectionChanged = (selectedRowData) => {
   setSelectedRowKeys(selectedRowData.selectedRowKeys);
  }

  return (
        <Fragment>
            <PageTitle 
            
            pageTitle={`${persianLanguage.word.general.HISTORY} ${persianLanguage.word.price.PRICE}`}
            />

            <button
                className="m-5 py-2 px-4 border border-transparent text-center text-sm transition-all shadow-md hover:shadow-lg focus:shadow-none active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
                type="button"
                onClick={getGoldPrices}
            >
                {persianLanguage.word.general.SEARCH}
            </button>

        <div className='date-picker-block m-5'>
          <div className="grid grid-cols-2 m-3 " >
            <div className="grid grid-cols-2 m-3">
              <span>
                {`${persianLanguage.word.general.FROM} ${persianLanguage.word.general.DATE}`}
                {selectedStartDate &&
                  <span> : {selectedStartDate}</span>
                }

              </span>
              <SimpleDatePickerInput
                changeDate={changeStartDate}
                unixDate={startUnixDate}
                selectedDate={selectedStartDate}
              />
            </div>
            <div className="grid grid-cols-2 m-3 align-middle">
              <span>
                {`${persianLanguage.word.general.UNTIL} ${persianLanguage.word.general.DATE}`}
                {selectedEndDate &&
                  <span>: {selectedEndDate}</span>
                }
              </span>
              <SimpleDatePickerInput 
                changeDate={changeEndDate}
                unixDate={endUnixDate}
                selectedDate={selectedEndDate}
              />
            </div>
          </div>

        </div>

          <DevextremeDataGrid
            dataGridId={"grid-container"}
            keyExpr={"id"}
            className="custom-datagrid-bg"
            dataSource={goldPrices}
            columns={columns}
            dataGridRef={dataGridRef}
            allowExportSelectedData={true}
            selectedRowKeys={selectedRowKeys}
            rtlEnabled={true}
            showBorders={true}
            remoteOperations={true}
            allowColumnResizing={true}
            columnHidingEnabled={true}
            exportEnabled={true}
            scrollingColumnRenderingMode={'virtual'}
            selectionMode={'multiple'}
            filterRowVisible={true}
            pagingDefaultPageSize={50}
            pagerShowPageSizeSelector={true}
            pagerShowNavigationButtons={true}
            pagerShowInfo={true}
            allowedPageSizes={DATAGRID_ALLOWED_PAGE_SIZES}
            columnChooserEnabled={true}
            columnChooserSelect={'select'}
            onSelectionChanged={onSelectionChanged}
          />

                  <div className='mb-[200px]'></div>

        </Fragment>
    );
}